// src/pages/ContactPage.js - Beautiful Working Contact Page
import React, { useState } from 'react';
import Loader from '../components/Loader';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      alert('Thank you for your message! We\'ll get back to you soon. 🇳🇬');
      setFormData({ name: '', email: '', phone: '', message: '' });
      setLoading(false);
    }, 2000);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return loading ? <Loader text="Loading menu..." /> : (
    <div className="main-container" style={{ background: '...', minHeight: '100vh' }}>
      {/* Contact Header */}
      <section style={{
        background: 'linear-gradient(135deg, #008751, #fb923c)',
        color: 'white',
        padding: '4rem 0',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
          <h1 style={{ fontSize: '3rem', marginBottom: '1rem' }}>
            📞 Contact Us 🇳🇬
          </h1>
          <p style={{ fontSize: '1.2rem', opacity: 0.9 }}>
            We'd love to hear from you! Get in touch with any questions
          </p>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section style={{ padding: '5rem 0', background: '#FFF8DC' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
          <div
            className="contact-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
              gap: '3rem'
            }}
          >
            <div className="contact-form-section">
              {/* Contact Form */}
              <div>
                <h2 style={{ color: '#008751', marginBottom: '2rem' }}>
                  📝 Send us a Message
                </h2>
                <form onSubmit={handleSubmit} style={{
                  background: 'white',
                  padding: '2rem',
                  borderRadius: '20px',
                  boxShadow: '0 8px 25px rgba(0,0,0,0.1)'
                }}>
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '0.5rem', 
                      fontWeight: '600',
                      color: '#374151'
                    }}>
                      Name *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      style={{
                        width: '100%',
                        padding: '0.8rem',
                        border: '2px solid #e9ecef',
                        borderRadius: '10px',
                        fontSize: '1rem',
                        outline: 'none',
                        transition: 'border-color 0.3s ease'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#008751'}
                      onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                    />
                  </div>
                  
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '0.5rem', 
                      fontWeight: '600',
                      color: '#374151'
                    }}>
                      Email *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      style={{
                        width: '100%',
                        padding: '0.8rem',
                        border: '2px solid #e9ecef',
                        borderRadius: '10px',
                        fontSize: '1rem',
                        outline: 'none',
                        transition: 'border-color 0.3s ease'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#008751'}
                      onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                    />
                  </div>
                  
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '0.5rem', 
                      fontWeight: '600',
                      color: '#374151'
                    }}>
                      Phone
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        padding: '0.8rem',
                        border: '2px solid #e9ecef',
                        borderRadius: '10px',
                        fontSize: '1rem',
                        outline: 'none',
                        transition: 'border-color 0.3s ease'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#008751'}
                      onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                    />
                  </div>
                  
                  <div style={{ marginBottom: '2rem' }}>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '0.5rem', 
                      fontWeight: '600',
                      color: '#374151'
                    }}>
                      Message *
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="5"
                      style={{
                        width: '100%',
                        padding: '0.8rem',
                        border: '2px solid #e9ecef',
                        borderRadius: '10px',
                        fontSize: '1rem',
                        resize: 'vertical',
                        outline: 'none',
                        transition: 'border-color 0.3s ease'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#008751'}
                      onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                    />
                  </div>
                  
                  <button 
                    type="submit" 
                    style={{
                      width: '100%',
                      background: 'linear-gradient(135deg, #008751, #fb923c)',
                      color: 'white',
                      border: 'none',
                      padding: '1rem 2rem',
                      borderRadius: '15px',
                      fontWeight: '700',
                      fontSize: '1.1rem',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease'
                    }}
                    onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                    onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                  >
                    📤 Send Message
                  </button>
                </form>
              </div>
            </div>

            <div className="contact-info-section">
              {/* Contact Info */}
              <div>
                <h2 style={{ color: '#008751', marginBottom: '2rem' }}>
                  📍 Get in Touch
                </h2>
                
                <div style={{
                  background: 'white',
                  padding: '2rem',
                  borderRadius: '20px',
                  boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
                  marginBottom: '2rem'
                }}>
                  <div style={{ marginBottom: '2rem' }}>
                    <h3 style={{ 
                      color: '#008751', 
                      marginBottom: '1rem',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      📞 Phone
                    </h3>
                    <p style={{ fontSize: '1.1rem', color: '#374151' }}>+234 801 234 5678</p>
                  </div>
                  
                  <div style={{ marginBottom: '2rem' }}>
                    <h3 style={{ 
                      color: '#008751', 
                      marginBottom: '1rem',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      📧 Email
                    </h3>
                    <p style={{ fontSize: '1.1rem', color: '#374151' }}>hello@tiwatinwa.com</p>
                  </div>
                  
                  <div style={{ marginBottom: '2rem' }}>
                    <h3 style={{ 
                      color: '#008751', 
                      marginBottom: '1rem',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      📍 Locations
                    </h3>
                    <p style={{ 
                      fontSize: '1.1rem', 
                      lineHeight: '1.6',
                      color: '#374151'
                    }}>
                      Lagos • Abuja • Port Harcourt<br/>
                      Delivery available across major Nigerian cities
                    </p>
                  </div>
                  
                  <div>
                    <h3 style={{ 
                      color: '#008751', 
                      marginBottom: '1rem',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      🕒 Hours
                    </h3>
                    <p style={{ 
                      fontSize: '1.1rem', 
                      lineHeight: '1.6',
                      color: '#374151'
                    }}>
                      Monday - Sunday: 9:00 AM - 11:00 PM<br/>
                      Fast delivery in 30-45 minutes
                    </p>
                  </div>
                </div>

                {/* Quick Contact Buttons */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '1rem'
                }}>
                  <a
                    href="tel:+2348012345678"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.5rem',
                      padding: '1rem',
                      background: 'linear-gradient(135deg, #22c55e, #16a34a)',
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '15px',
                      fontWeight: '600',
                      transition: 'transform 0.3s ease'
                    }}
                    onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                    onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                  >
                    📞 Call Now
                  </a>
                  
                  <a
                    href="https://wa.me/2348012345678"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.5rem',
                      padding: '1rem',
                      background: 'linear-gradient(135deg, #25d366, #20ba5a)',
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '15px',
                      fontWeight: '600',
                      transition: 'transform 0.3s ease'
                    }}
                    onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                    onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                  >
                    💬 WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;